import * as React from 'react';
import { DappUI, logout, useGetAccountInfo } from '@elrondnetwork/dapp-core';
import { contractAddress } from 'config';
import { routeNames } from 'routes';
const TopInfo = () => {
  const { address, account } = useGetAccountInfo();
  const isLoggedIn = Boolean(address);
  const handleLogout = () => {
    logout(`${window.location.origin}/unlock`);
  };
  return (
    <div className='text-black' data-testid='topInfo'>
      <div className='mb-1'>
        {isLoggedIn && (
          <button
            type='button'
            className='btn btn-primary btn-lg btn-block'
            onClick={handleLogout}
            style={{ fontWeight: 'bolder' }}
          >
            Log Out
          </button>
        )}
      </div>
      <div className='mb-1'>
        <span className='opacity-6 mr-1'>Connected as:</span>
        <span data-testid='accountAddress'> {address}</span>
      </div>
      <h1 style={{ paddingTop: '100px', paddingBottom: '30px' }}>
        Space Robots Background Collection
      </h1>
    </div>
  );
};

export default TopInfo;
